var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore, createContainer } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { NoEntityError } from "framework/validation/validatableentity";
import { setEntityField, setStateField } from "framework/state/entity";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: { id: 0, name: '' }, errors: __assign({}, NoEntityError) });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setEntityField: setEntityField,
        setStateField: setStateField,
    },
    name: "EventsPlanningCompetitionDancesItemEdit"
});
var useState = createHook(store);
var Container = createContainer(store, {
    onInit: function () { return function (_a, _b) {
        var setState = _a.setState;
        var item = _b.item;
        setState(function (draft) {
            draft.entity = item;
        });
    }; },
});
export { Container as EventsPlanningCompetitionDancesItemEditContainer, StateDefaults as EventsPlanningCompetitionDancesItemEditDefaults, useState as useEventsPlanningCompetitionDancesItemEdit, };
